import React from 'react'
import ReactDOM from 'react-dom/client'
import App from '@/App'
import '@/index.css'
import { AuthProvider } from '@/context/AuthContext'
import { BiometricProvider } from '@/context/BiometricContext'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthProvider>
      <BiometricProvider>
        <App />
      </BiometricProvider>
    </AuthProvider>
  </React.StrictMode>,
)
